export default __webpack_public_path__ + "static/media/2434.8863153e.jpg";